import { RouteProp, useRoute } from "@react-navigation/native";
import { ClubNavigatorParamList } from "../../../navigators/ClubNavigator";
import { Perk } from "./Perk";

export const PerkQueryRenderer = () => {
  const route = useRoute<RouteProp<ClubNavigatorParamList, "Perk">>();

  return <Perk perkId={route.params.perkId} />;
};
